var NODE_MAP = {};

export default NODE_MAP;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/canvas/node-map.js
// module id = 87
// module chunks = 0